module.exports = __webpack_public_path__ + "static/media/me-2.047b2d63.jpg";